import { render, staticRenderFns } from "./CashupQuotations.vue?vue&type=template&id=ded575a6&"
import script from "./CashupQuotations.vue?vue&type=script&lang=js&"
export * from "./CashupQuotations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports